var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAllSides = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_6",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 256,
    height: 256
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 256V1.11901e-05L1.11901e-05 0L0 256H256Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_7_6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 220,
    height: 220,
    rx: 5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 220,
    height: 220,
    rx: 5,
    stroke: "black",
    strokeWidth: 20,
    mask: "url(#path-2-inside-1_7_6)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAllSides);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/all-sides.a9ef0cf2c2c8ac1435195a487edbf82e.svg";